const topicItems = [
  { id: 1, label: '狂飙全集免费', count: '128万', hot: true },
  { id: 2, label: '庆余年第二季', count: '106万', hot: true },
  { id: 3, label: '高清不缓冲', count: '95万', hot: true },
  { id: 4, label: '长安十二时辰', count: '87万', hot: false },
  { id: 5, label: '免费追剧平台', count: '82万', hot: true },
  { id: 6, label: '古装剧推荐', count: '76万', hot: false },
  { id: 7, label: '被窝网电视剧', count: '71万', hot: true },
  { id: 8, label: '韩剧全集在线', count: '65万', hot: false },
  { id: 9, label: '悬疑剧高分', count: '58万', hot: false },
  { id: 10, label: '繁花沪语版', count: '52万', hot: false },
  { id: 11, label: '每日更新剧集', count: '48万', hot: true },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            热门话题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门话题 · 剧迷都在讨论什么</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">全网追剧热点实时追踪，加入话题讨论</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <span
              key={topic.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm cursor-pointer transition-all duration-300 whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100 text-accent-800 hover:bg-accent-200 font-medium'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
              {topic.label}
              <span className={`text-xs ${topic.hot ? 'text-accent-500' : 'text-foreground-400'}`}>{topic.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}